import { render } from "./shinsei_Ringishoedit.vue?vue&type=template&id=2259305c&scoped=true&ts=true"
import script from "./shinsei_Ringishoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Ringishoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Ringishoedit.vue?vue&type=style&index=0&id=2259305c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2259305c"]])

export default __exports__